function createEventBus(elemId) {
  // Create a fake element to serve as channel for events
  const elem = document.createElement("div");
  elem.style.display = "none";
  document.body.appendChild(elem);

  return {
    emit(eventName, payload) {
      elem.dispatchEvent(new CustomEvent(eventName, { detail: payload }));
      console.debug(`EVENT: ${eventName}`);
    },

    subscribe(eventName, listener) {
      const _listener = (e) => listener(e.detail);
      elem.addEventListener(eventName, _listener, false);
      return {
        unsubscribe() {
          elem.removeEventListener(eventName, _listener);
        },
      };
    },

    subscribeAll(eventNames, listener) {
      const obj = this;
      eventNames.forEach(function (eventName) {
        obj.subscribe(eventName, listener);
      });
    },
  };
}

// singleton event bus
export const EventBus = createEventBus();
export const Events = {
  APP_LOADED: "app-loaded",
  PDF_UPLOADED: "pdf-uploaded", // payload = { data, filename } or { url, filename }
  PDF_REJECTED: "pdf-rejected", // payload = { reason }
  PDF_ERROR: "pdf-error",
  SHOW_PREVIEW: "show-preview",
  HIDE_PREVIEW: "hide-preview",
  HIDE_PLACEHOLDER: "hide-placeholder",
  SHOW_PLACEHOLDER_PREPARING_PDF: "show-placeholder--preparing-pdf",
  SHOW_PLACEHOLDER_GENERATING_PDF: "show-placeholder--generating-pdf",
  ANCHOR_ADDED: "anchor-added", // payload = { anchorId, page }
  ANCHOR_DELETED: "anchor-deleted", // payload = { anchorId, page }
  ANCHOR_MOVED: "anchor-moved", // payload = { anchorId, fromPage, page }
  EXPORT_DONE: "export-done", // payload = { data, filename }
  ANCHOR_CLICKED: "anchor-clicked", // payload = { anchorId }
  PAGE_CONTAINER_CLICKED: "page-container-clicked",
  ZOOM_VALUE_UPDATED: "zoom-updated", // payload = { zoom, screen } <- new zoom value requested
  SCALE_CHANGED: "scale-changed", // payload = { zoom, scale, screen } <- zoom processed, trigger rerender at new scale
  PAGE_IN_VIEW: "page-in-view", // payload = { page, screen }
};
